var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInformationCircle = function SvgInformationCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12,22c-1.3,0-2.6-0.3-3.8-0.8C7,20.7,5.9,20,4.9,19.1s-1.7-2-2.2-3.2C2.3,14.6,2,13.3,2,12c0-2.7,1-5.2,2.9-7.1 C6.8,3,9.3,2,12,2c2.7,0,5.2,1,7.1,2.9C21,6.8,22,9.3,22,12c0,1.3-0.3,2.6-0.8,3.8c-0.5,1.2-1.2,2.3-2.2,3.2 c-0.9,0.9-2,1.7-3.2,2.2S13.3,22,12,22z M12,4C9.9,4,7.9,4.8,6.3,6.3C4.8,7.9,4,9.9,4,12c0,1.1,0.2,2.1,0.6,3.1s1,1.8,1.7,2.6 C7.1,18.4,8,19,8.9,19.4c1.9,0.8,4.2,0.8,6.1,0c1-0.4,1.8-1,2.6-1.7c0.7-0.7,1.3-1.6,1.7-2.6c0.4-1,0.6-2,0.6-3.1 c0-2.1-0.8-4.1-2.3-5.7C16.1,4.8,14.1,4,12,4z M13,17h-1c-0.6,0-1-0.4-1-1v-3c-0.6,0-1-0.4-1-1s0.4-1,1-1h1c0.6,0,1,0.4,1,1v3 c0.6,0,1,0.4,1,1S13.6,17,13,17z M12,9c-0.6,0-1-0.4-1-1s0.4-1,1-1h0c0.6,0,1,0.4,1,1S12.6,9,12,9z"
  }))));
};
export default SvgInformationCircle;